// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"475":"db962b39","839":"2bb6279f"}[chunkId] + ".chunk.css";
};